/// <amd-module name="Wit/DeliveryPlans/Views/DeliveryPlansHubView" />
import * as React from "react";
import { Components, IVssLayoutManager, VssComponent } from "VSS/Platform/Layout";
import { Header } from "VSSUI/Header";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { Page } from "VSSUI/Page";
import { Surface, SurfaceBackground } from "VSSUI/Surface";
import { NewPlanPanel } from "Wit/DeliveryPlans/NewPlanPanel/NewPlanPanel";
import { PlansTable } from "Wit/DeliveryPlans/PlansTable/PlansTable";
import * as Resources from "Wit/DeliveryPlans/Resources";

export class DeliveryPlansHubViewComponent extends VssComponent {
    public render(): JSX.Element {
        return (
            <Surface background={SurfaceBackground.neutral}>
                <Page className="delivery-plans-page flex-grow flex-column ">
                    <Header title={Resources.DeliveryPlansHeader} commandBarItems={this._commandBarItems} />
                    <div className="page-content page-content-top">
                        <PlansTable onActivateNewPlan={this._openNewPlanPanel} />
                    </div>
                </Page>
            </Surface>
        );
    }

    private _openNewPlanPanel = () => {
        const layoutManager = this.context.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        layoutManager.renderCallout(onDismiss => {
            return React.createElement(NewPlanPanel, { onDismiss });
        });
    };

    private _commandBarItems: IHeaderCommandBarItem[] = [
        {
            iconProps: { iconName: "Add" },
            id: "new-plan",
            important: true,
            isPrimary: true,
            onActivate: (menuItem: any, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
                this._openNewPlanPanel();
            },
            text: Resources.NewPlanButtonText
        }
    ];
}

Components.add("delivery-plans-hub-view-component", DeliveryPlansHubViewComponent);
